module.exports = __webpack_public_path__ + "img/icon-facebook.dc087ee8.svg";